
    import * as React from 'react';

    const PlayFilled72 = ({ color = 'currentcolor', height = '72px', width = '72px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 72 72" fill="none" style={svgStyle}><circle cx={36} cy={36} r={36} fillOpacity={0.7} /><path d="M54 36.5L27 52V21L54 36.5Z" fill="white" stroke="white" strokeWidth={1.5} /></svg>
        </div>
      );
    };

    PlayFilled72.displayName = 'PlayFilled72';

    export default PlayFilled72;
  